import { useParams } from 'react-router-dom'

// Routes use /:username which captures the leading ~ as part of the value.
// This hook strips it so callers always get a plain username for API calls.
export function useUsername(): string {
  const { username } = useParams()
  return (username ?? '').replace(/^~/, '')
}
